import Model from "./Model.js";

/**
 * `UploadedFile` materialize the data returned from the server when
 * uploading a file. It contains meta-data, as well as the file content.
 *
 * @param {string} id - Id of the uploaded file.
 * @param {string} filename - Name of the uploaded file.
 * @param {string} fileContent - Base64 encoded content of the file.
 * @param {string} contentType - Content type of the uploaded file.
 * @param {string} path - Path where the uploaded file is accessible.
 */
export default class UploadedFile extends Model {
	constructor({ id, filename, fileContent, contentType, path }) {
		super(...arguments);

		this._id = id;
		this._filename = filename;
		this._contentType = contentType;
		this._path = path;
		this._fileContent = fileContent;
	}

	getId() {
		return this._id;
	}

	getFilename() {
		return this._filename;
	}

	getContentType() {
		return this._contentType;
	}

	getPath() {
		return this._path;
	}

	getContent() {
		return this._fileContent;
	}

	asBase64Url() {
		return `data:${this.getContentType()};base64,${this.getContent()}`;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.id = this._id;
		properties.fileName = this._filename;
		properties.contentType = this._contentType;

		return properties;
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.filename = data.fileName;
	}
}
